import React, { useCallback } from "react";
import type { GeneratedSlides, SlideStyle, ColorScheme } from "../types";
import { HeaderSection } from "../result/HeaderSection";
import { SlidePreviewSection } from "../result/SlidePreviewSection";
import { SlideThumbnails } from "../result/SlideThumbnails";
import { StructureSection } from "../result/StructureSection";
import { ResourcesSection } from "../result/ResourcesSection";
import { TipsSection } from "../result/TipsSection";
import { ActionButtons } from "../result/ActionButtons";

interface ResultStepProps {
  generatedSlides: GeneratedSlides;
  slideStyle: SlideStyle;
  colorScheme: ColorScheme;
  selectedSlide: number;
  onSelectSlide: (index: number) => void;
  onSave?: () => void;
  onRegenerate?: () => void;
  onDownload?: (format: string) => void;
}

export const ResultStep: React.FC<ResultStepProps> = ({
  generatedSlides,
  slideStyle,
  colorScheme,
  selectedSlide,
  onSelectSlide,
  onSave,
  onRegenerate,
  onDownload,
}) => {
  const handleCopyContent = useCallback(() => {
    const content = generatedSlides.slides
      .map(
        (slide) =>
          `Slide ${slide.id}: ${slide.title}\n${
            Array.isArray(slide.content)
              ? slide.content.join("\n")
              : slide.content
          }\n---`,
      )
      .join("\n\n");

    navigator.clipboard.writeText(content);
    alert("Conteúdo dos slides copiado!");
  }, [generatedSlides.slides]);

  return (
    <div className="p-6">
      <div className="mb-8">
        <HeaderSection
          generatedSlides={generatedSlides}
          slideStyle={slideStyle}
          colorScheme={colorScheme}
        />

        <div className="mb-8 mt-6">
          <div className="flex gap-6">
            <SlidePreviewSection
              generatedSlides={generatedSlides}
              selectedSlide={selectedSlide}
              slideStyle={slideStyle}
              colorScheme={colorScheme}
            />

            <SlideThumbnails
              generatedSlides={generatedSlides}
              selectedSlide={selectedSlide}
              onSelectSlide={onSelectSlide}
              colorScheme={colorScheme}
            />
          </div>
        </div>

        <StructureSection
          generatedSlides={generatedSlides}
          colorScheme={colorScheme}
        />

        <div className="grid md:grid-cols-2 gap-6">
          <ResourcesSection
            generatedSlides={generatedSlides}
            colorScheme={colorScheme}
          />

          <TipsSection
            generatedSlides={generatedSlides}
            colorScheme={colorScheme}
          />
        </div>
      </div>

      <ActionButtons
        generatedSlides={generatedSlides}
        colorScheme={colorScheme}
        onSave={onSave}
        onCopy={handleCopyContent}
        onDownload={onDownload}
        onRegenerate={onRegenerate}
      />
    </div>
  );
};
